export default "__VITE_ASSET__c7de47e4__"